import api from '@/api/'

export const strategyCommand = {
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      okText: '确定',
      cancelText: '取消',
      async onOk() {
        const res = await api.deleteKeyword({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
